export default {
    layout: {
        zh: '中文简体',
        en: 'English',
        kr: '한국어',
        tc:'中文繁体',
        th:'泰语ภาษาไทย',
        vn:'Việt Nam'
    },
    footer:{
        desc:''
    },
    menu: {
        home: '首页',
        node: '节点',
        exchange: '兑换',
        staking: '质押',
        me: '我的',
    },
    home: {
        ecological: '生态节点',
        more: '查看更多',
        genesis: '钻石节点',
        gold: '黄金节点',
       onlyLeft: '仅剩',
       coin: '配币比',
       subscription: '购买节点',
       application: '生态应用场景',
       desc1: '商城积分兑换与商品支付',
       desc2: '节点认购、质押收益与治理投票',
       desc3: '消费资产兑换(RWA映射)',
       desc4: '商家让利及分红激励',
       desc5: '平台手续费结算及分润分配',
       community: 'DAO 社区治理 及投票决策',
       partners: '合作伙伴',
       contact: '联系我们',
       limited: '限量',
       mat: '席',
       lock: '锁仓释放',
       sky:'天'
    },
    node:{
        ecology: '生态节点',
        meNode: '我的节点',
        genesis: '钻石节点',
        onlyLeft: '仅剩',
        coin: '配币比',
       subscription: '购买节点',
       diamond: '钻石节点',
       bronze:'青铜节点',
       revenue: '查看收益',
       gold: '黄金节点',
       silver: '白银节点',
       noNode: '还没有节点，立即认购',
       totalCollection: '总领取',
       toBeClaimed: '待领取',
       claimed: '领取',
       totalRelease: '总释放',
       released: '已释放',
       toBeReleased: '待释放',
       genesisReleased: '钻石节点释放',
       more: '下拉加载更多',
       nodeSubscription: '节点认购',
       receivedTo: '领取至',
       networkFee: '网络费用',
       confirmSubscription: '确定认购',
       progress: '交易执行中',
       executionSuccessful: '执行成功',
       at: '在',
       view: '上查看',
       releaseRecord: '释放记录',
       claimRecord: '领取记录',
       nonce: 'Nonce',
       claimIncome: '领取收益',
       quantityClaimed: '领取数量',
       pickup: '可领取',
       all: '全部',
       confirmToReceive: '确定领取',
       node0:'钻石节点',
       node1:'铂金节点',
       node2:'黄金节点',
       node3:'翡翠节点',
       node4:'白银节点',
       node5:'青铜节点',

       release1:'KOL 激励',
       release2:'全球空投',
       release3:'流动性池',
       release4:'创始团队',
       release5:'生态基金',
       release6:'机构',
       release7:'全球节点',
       release8:'生态矿池',
       release9:'质押矿池',
       

       success:'操作成功',
       error:'操作失败',
       nocount:'该节点已经售罄'
    },
    exchange:{
        at: '在',
        view: '上查看',
        more:'更多',
        indicator:'指标',
        market:'市价兑换',
        payment:'支付',
        all:'全部',
        received:'收到',
        slippage:'滑点',
        minimum:'收到的最小值',
        cost:'网络费用',
        confirmExchange:'确定兑换',
        record:'历史记录',
        completed:'已完成',
        error:'失败',
        downMore:'下拉加载更多',
        price:'价格',
        progress:'交易执行中',
        wallet:'发起钱包',
        refuse:'拒绝',
       nodeSubscription: '节点认购',
       executionSuccessful: '执行成功',
       nonce: 'Nonce',
       confirm:'确定',
    },
    me:{
       assets: '总资产',
       recharge: '充值',
       transfer: '转出',
       record: '历史记录',
    },
    recharge:{
       recharge: '充值',
        title: '该地址仅支持 NEX 相关资产',
        address: '收款地址',
        copy: '复制',
        share: '分享',
    },
    record:{
        record: '记录',
        all: '全部',
       recharge: '充值',
       transfer: '转出',
       claimed: '领取',
     },
     transfer:{
        transfer: '转出',
        address: '转出地址',
        transferCoin: '转账代币',
        pla: '请输入转出地址',
        network: '转账网络',
        mainNetwork:'选择主网',
        transferAmount: '转出金额',
        withdraw: '最少提现20',
        all: '全部',
        balance: '可用余额',
        tips: '请认真核对转出地址和网络，一经上链，资产将不可追回',
        amountReceived: '到账数量',
        free: '网络手续费',
     }
};
